import {
  dateFormatter, getLegalEntityName, localeFormatter, smevCheckWithContentFormatter, szltStatusFormatter,
} from '../../../utils/formatters';

export const szltColumns = [
  {
    dataField: 'number',
    text: 'Номер записи',
    headerClassName: 'registry-number-column',
    formatter: (a, item) => smevCheckWithContentFormatter(a || 'Номер не указан', item?.checks_status || ''),
  },
  {
    dataField: 'created_at',
    text: 'Дата внесения записи',
    headerClassName: 'registry-date-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'commercial_name',
    text: 'Наименование СЗЛТ',
    headerClassName: 'registry-commercial-name-column',
    formatter: (_, a) => getLegalEntityName(a),
    sortField: 'full_name',
  },
  {
    dataField: 'inn',
    text: 'ИНН',
    headerClassName: 'registry-inn-column',
  },
  {
    dataField: 'ogrn',
    text: 'ОГРН/ОГРНИП',
    headerClassName: 'registry-ogrn-column',
  },
  {
    dataField: 'status',
    text: 'Статус',
    headerClassName: 'registry-status-column',
    formatter: a => szltStatusFormatter(a),
  },
  {
    dataField: 'effective_date',
    text: 'Дата начала срока действия права',
    headerClassName: 'effective-date',
    formatter: dateFormatter,
  },
  {
    dataField: 'expiration_date',
    text: 'Дата окончания срока действия права',
    headerClassName: 'expiration-date-column',
    formatter: dateFormatter,
  },
];

export const additionalSzltColumns = [
  {
    dataField: 'legal_entity_type',
    headerClassName: 'additional-column',
    formatter: a => localeFormatter('user.type', a),
  },
  {
    dataField: 'last_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'first_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'middle_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'birth_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'gender',
    headerClassName: 'additional-column',
    formatter: a => (a ? localeFormatter('gender', a) : ''),
  },
  {
    dataField: 'citizenship',
    headerClassName: 'additional-column',
    formatter: a => (a ? localeFormatter('citizenship.type', a) : ''),
  },
  {
    dataField: 'registration_type',
    headerClassName: 'additional-column',
    formatter: a => (a ? localeFormatter('registration.type', a) : ''),
  },
  {
    dataField: 'place_of_birth',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'snils',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'phone',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'email',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'identity_type',
    headerClassName: 'additional-column',
    formatter: a => localeFormatter('identity.type', a),
  },
  {
    dataField: 'identity_series',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'identity_number',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'identity_issue_date',
    headerClassName: 'additional-column',
    formatter: dateFormatter,
  },
  {
    dataField: 'identity_issuer',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'address',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'commercial_name',
    headerClassName: 'additional-column',
    sortField: 'commercial_name',
  },
  {
    dataField: 'short_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'full_name',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'legal_address',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'web_site',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'software_names',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'database_address',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'server_address',
    headerClassName: 'additional-column',
  },
  {
    dataField: 'legal_entity_form',
    headerClassName: 'additional-column',
  },
];
